module.exports = __webpack_public_path__ + "static/mid-33d6d7967f20331b76cdd7174c1562a5.jpg";